export default __webpack_public_path__ + "static/media/passgenPython.2583315a.JPG";